import { LastVisitedService } from "common/types/last-visited";
import { LocalStorage } from "common/types/local-storage";

export const lastVisitedService = (
  localStorage: LocalStorage,
): LastVisitedService => ({
  get: () => localStorage.get<string>("last-visited"),
  set: (path: string) => localStorage.set("last-visited", path),
});
